import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';
import { Modals } from '@/helpers/modals';
import { useModalsStore } from '@/store';
import { ScVipTransferGuestCard } from './styled';

export const VipTransferGuestCard = () => {
  const { t } = useTranslation('vip');
  const open = useModalsStore.use.open();

  const handleOpenRegistration = useCallback(() => {
    open(Modals.Registration);
  }, [open]);

  return (
    <ScVipTransferGuestCard>
      <div className="content-wrapper">
        <ImageComponent
          alt="crown-benefits"
          height={40}
          src="/vip/crown-benefits.webp"
          width={40}
        />
        <span className="title">{t('steps.vipTransfer.guestCard.title')}</span>
        <span className="description">
          {t('steps.vipTransfer.guestCard.description')}
        </span>
      </div>
      <Button height="40px" onClick={handleOpenRegistration} primary>
        {t('steps.vipTransfer.guestCard.ctaBtn')}
      </Button>
    </ScVipTransferGuestCard>
  );
};
